import { render, staticRenderFns } from "./HospitalList.vue?vue&type=template&id=701d1bd2&"
import script from "./HospitalList.vue?vue&type=script&lang=js&"
export * from "./HospitalList.vue?vue&type=script&lang=js&"
import style0 from "./HospitalList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports